module.exports = {
  condition: {
    key: 'condition',
    label: 'Condition',
  },
  procedure: {
    key: 'procedure',
    label: 'Procedure',
  },
  observation: {
    key: 'observation',
    label: 'Observation',
  },
  immunizationRecommendation: {
    key: 'immunizationRecommendation',
    label: 'Immunization Recommendation',
  },
};